import type { Product } from '@/lib/api.types'

import TicketsListView from '../ListView'

interface TicketsListProps {
  categoryName: string
  coverImageUrl?: string
  products: Product[]
  accessibilityMode?: boolean
  currency?: string
}

const TicketsList = (props: TicketsListProps) => <TicketsListView {...props} cardType="ticket" />

export default TicketsList
